import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerWordleTranslations } from "./i18n";
import {
  applyVerdict,
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
} from "./progress";
import { emptySolution, type WordleSolution } from "./solution";
import type { WordleDefinition, WordleProgress, WordleSubmission } from "./types";

registerWordleTranslations(i18n);

/**
 * No `localFeedback`: the dictionary and the word stay on the server. `applyVerdict` makes
 * the marks of each guess part of the autosaved history (ADR 0041, 0054).
 */
export const wordleModule: PuzzleTypeModule<
  WordleDefinition,
  WordleSubmission,
  WordleProgress,
  WordleSolution
> = {
  key: "wordle",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
  applyVerdict,
};
